import { httpRequest } from "../../../../utils/HttpRequest";
import { IPage } from "../../../../types/FmsTypes";
import { IMdMarketingTypeDetail, IMdMarketingTypeFields, IMdMarketingTypeSearch } from "./allMemberMarketingTypeTypes";


class AllMemberMarketingTypeService {
    /**
     * 新增会员营销类型
     * @param insertVo 
     * @returns 
     */
    async insert(insertVo: IMdMarketingTypeDetail) {
        const appInsertUrl = "/auth/marketing-type-assignment/insert";
        let ret = await httpRequest.post<IMdMarketingTypeDetail>(appInsertUrl, insertVo);
        return ret;
    }

    /**
     * 更新会员营销类型
     * @param insertVo 
     * @returns 
     */
    async update(insertVo: IMdMarketingTypeFields) {
        const appInsertUrl = "/auth/marketing-type-assignment/update";
        let ret = await httpRequest.post<IMdMarketingTypeDetail>(appInsertUrl, insertVo);
        return ret;
    }

    /**
     * 分页查询会员营销类型
     * @param insertVo 
     * @returns 
     */
    async page(insertVo: IMdMarketingTypeSearch) {
        const appInsertUrl = "/auth/marketing-type-assignment/findPage";
        let ret = await httpRequest.post<IPage<IMdMarketingTypeDetail>>(appInsertUrl, insertVo);
        return ret;
    }

    /**
     * 查询会员营销类型列表
     * @param insertVo 
     * @returns 
     */
    async find(insertVo: IMdMarketingTypeFields) {
        const appInsertUrl = "/auth/marketing-type-assignment/find";
        let { retData } = await httpRequest.post<IMdMarketingTypeDetail[]>(appInsertUrl, insertVo);
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }
    /**
     * 查询某个会员营销类型
     * @param insertVo
     * @returns 
     */
    async findOne(insertVo: IMdMarketingTypeSearch) {
        const appInsertUrl = `/auth/marketing-type-assignment/one`;
        let ret = await httpRequest.post<IMdMarketingTypeDetail>(appInsertUrl, insertVo);
        return ret;
    }

}

export const allMemberMarketingTypeService = new AllMemberMarketingTypeService();
